import { render, staticRenderFns } from "./PillTabs.vue?vue&type=template&id=b7f9114e&scoped=true"
import script from "./PillTabs.vue?vue&type=script&lang=js"
export * from "./PillTabs.vue?vue&type=script&lang=js"
import style0 from "./PillTabs.vue?vue&type=style&index=0&id=b7f9114e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f9114e",
  null
  
)

export default component.exports